<template>
  <v-container class="full-height">
    <div v-if="!loading" class="d-flex pb-4">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Recherche"
        single-line
        hide-details
        class="pb-4 pt-0 mt-0"
        color="third"
        @click.stop
      />
    </div>
    <v-data-table
      v-if="!loading"
      :headers="headers"
      :hide-default-footer="true"
      :items-per-page="-1"
      :items="horsesWithSessions"
      :search="search"
    />
    <div v-else class="d-flex justify-center align-center full-height">
      <Loader />
    </div>
  </v-container>
</template>

<script>
import { onBeforeMount, ref, computed } from '@vue/composition-api';
import { format, fromUnixTime, getUnixTime, addYears } from 'date-fns';
import { fr } from 'date-fns/esm/locale';
import { contentTypeSessions } from '@/helpers/amplify';

import Loader from '@/components/common/Loader.vue';
import store from '@/store';

export default {
  components: { Loader },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const selectedDate = computed(() => store.getters.selectedDate);
    const loading = ref(false);
    const search = ref(null);

    const customerHorses = ref([]);

    const horsesWithSessions = ref([]);

    const headers = [
      { text: 'Nom', value: 'horseName', align: 'center', sortable: false, width: '25%' },
      { text: 'Chevaux Type', value: 'horseType', align: 'center', sortable: false, width: '15%' },
      { text: 'Session Nom', value: 'sessionName', align: 'center', sortable: false, width: '25%' },
      { text: 'Date de la séance', value: 'sessionDate', align: 'center', sortable: false, width: '15%' },
      { text: 'Debut', value: 'sessionStart', align: 'center', sortable: false, width: '10%' },
      { text: 'Fin', value: 'sessionEnd', align: 'center', sortable: false, width: '10%' }
    ];

    onBeforeMount(async () => {
      loading.value = true;

      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }

      customerHorses.value = store.getters.horsesFromCustomer(props.customer.uuid);

      if (!customerHorses.value.length) {
        loading.value = false;
        return;
      }


      const start = getUnixTime(new Date(selectedDate.value));
      const end = getUnixTime(addYears(new Date(fromUnixTime(start)), 1));

      customerHorses.value.map(async horse => {
        await contentTypeSessions(horse, start, end).then(sessions => {
          if (sessions.length > 0) {
            sessions.forEach(session => {
              horsesWithSessions.value.push({
                horseName: horse.horse_name,
                horseType: horse.horse_type,
                sessionName: session.name,
                sessionDate: format(fromUnixTime(session.start_time), 'yyyy-MM-dd', { locale: fr }),
                sessionStart: format(fromUnixTime(session.start_time), 'HH:mm', { locale: fr }),
                sessionEnd: format(fromUnixTime(session.end_time), 'HH:mm', { locale: fr })
              });
            });
          }
        });
      });

      loading.value = false;
    });

    return { headers, loading, search, horsesWithSessions };
  }
};
</script>
